import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class SemiCircleUtilService {

    getSemicircleAngleLength(fromAngle: number, toAngle: number, perimeter: number): number {
        if (fromAngle <= toAngle) {
            return perimeter * (toAngle - fromAngle) / 360;
        } else {
            return perimeter * (360 - fromAngle + toAngle) / 360;
        }
    }

}
